import { render, staticRenderFns } from "./ListAutocomplete.vue?vue&type=template&id=2521483f&scoped=true"
import script from "./ListAutocomplete.vue?vue&type=script&lang=js"
export * from "./ListAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./ListAutocomplete.vue?vue&type=style&index=0&id=2521483f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521483f",
  null
  
)

export default component.exports